import { type ApplicationSteps, type PartialRecord } from 'share/types'
import { pathnames } from 'utils/constants'

export const getDamuProgramPaths = (key: ApplicationSteps, needSpouseConsent: boolean) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    UPDATE_LOAN_DATA_IN_TELEMARKETING: pathnames['internal-step-loader'],
    FETCH_DDOCS: pathnames['digital-doc'],
    CHECK_ELICENSE: pathnames['damu-verification'],

    // Colvir
    OPEN_FL_CARD: pathnames['open-borrower-account'],
    OPEN_UL_CARD: pathnames['open-borrower-account'],
    OPEN_BORROWER_ACCOUNT: pathnames['open-borrower-account'],
    UPLOAD_BANK_DATA_IN_TELEMARKETING: pathnames['open-borrower-account'],

    // DAMU First signing steps
    SET_PAY_DAY: pathnames['documents-sign'],
    // FETCH_OWN_PROGRAM_SPOUSE_PERSONAL_INFO: needSpouseConsent
    FETCH_SPOUSE_PERSONAL_INFO_FOR_CONSENT: needSpouseConsent
      ? pathnames['spouse-confirmation']
      : pathnames['documents-sign'],
    SIGN_SPOUSE_DOCS_AITU: pathnames['internal-step-loader'],
    SEND_SPOUSE_SIGNING_SMS: pathnames['internal-step-loader'],
    GET_CORP_CARD_DATA: pathnames['documents-sign'],
    GENERATE_MAIN_DOCUMENTS: pathnames['documents-sign'],
    GENERATE_DOCUMENTS_SIGNED_BY_ECP: pathnames['documents-sign'],
    CREATE_APPLICATION_IN_CRED_ADMIN: pathnames['documents-sign'],
    WAIT_FOR_CONFIRMATION_FROM_CRED_ADMIN: pathnames['documents-sign'],
    SIGN_DOCS_AITU_DAMU: pathnames['documents-sign'],
    SIGN_BANK_LOAN_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],

    // Damu countdown steps
    DAMU_CREATE_APPLICATION: pathnames['damu-countdown'],
    DAMU_OBLIGATION_CHECK: pathnames['damu-countdown'],

    // DAMU Second signing steps
    REGISTER_IN_COLVIR_DAMU_PROGRAM: pathnames['damu-second-confirmation'],
    GENERATE_REPAYMENT_SCHEDULE: pathnames['damu-second-confirmation'],
    CREATE_MORTGAGE: pathnames['damu-second-confirmation'],
    SEND_ADDITIONAL_DOCUMENTS_TO_CRED_ADMIN: pathnames['damu-second-confirmation'],
    SECOND_CONFIRMATION_FROM_CRED_ADMIN: pathnames['damu-second-confirmation'],
    SIGN_REPAYMENT_SCHEDULE_WITH_AITU: pathnames['repayment-schedule-sign'],

    // Final steps
    SIGN_REPAYMENT_SCHEDULE_BY_BANK: pathnames['internal-step-loader'],
    LOAN_ACTUALIZE: pathnames['internal-step-loader']

    // Probaby not used steps
    // DAMU_UPDATE_APPLICATION: pathnames['internal-step-loader'],
    // UPDATE_APPLICATION_STATUS_COMPLETE_IN_CRED_ADMIN: pathnames['internal-step-loader'],
    // SEND_MAIN_DOCUMENTS_CLIENTS_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    // SEND_BANK_LOAN_AGREEMENTS_BANK_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    // SEND_BANK_REPAYMENT_SCHEDULE_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    // SIGN_PDF_BANK_LOAN_AGREEMENT_AITU: pathnames['biometry'],
  }
  return paths[key]
}
